import { useState } from "react";
import { FaXmark } from "react-icons/fa6";

function DefaultModal({
  close,
  icon,
  iconClass,
  headline,
  content,
  addedContent,
  formClass,
  onSubmit,
  labelClass,
  label,
  placeholder,
  inputClass,
  leftbtn,
  leftbtnfunc,
  rightbtn,
  rightbtnfunc,
  leftbtnClass,
  rightbtnClass,
  inputValue,
  onChangeValue,
  inputError,
  disabled,
}) {
  return (
    <main
      className="tw-fixed tw-z-20 tw-left-0 tw-top-0 tw-w-screen tw-h-screen tw-overflow-auto"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="tw-flex tw-flex-col tw-h-full tw-items-center tw-justify-center">
        <section className="tw-bg-white tw-w-[90%] md:tw-w-[35%] tw-h-auto tw-p-8 tw-rounded-xl">
          <span className="tw-flex tw-flex-end tw-justify-end tw-cursor-pointer">
            <FaXmark onClick={close} />
          </span>

          <div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-gap-y-2">
            <div className="">
              <img
                src={icon}
                alt={headline + " icon"}
                className={`${iconClass} tw-w-auto `}
              />
            </div>

            <div className="tw-flex tw-flex-col tw-items-center tw-jusity-center tw-text-center">
              <span className="tw-font-semibold tw-text-lg ">{headline}</span>
              <p>{content}</p>
            </div>

            <div>{addedContent}</div>

            <form className={`tw-w-full ${formClass}`} onSubmit={onSubmit}>
              <label className={`tw-w-full ${labelClass} `} htmlFor={label}>
                <span className="tw-text-sm">{label}</span>
                <input
                  type="text"
                  id={label}
                  placeholder={placeholder}
                  value={inputValue}
                  onChange={onChangeValue}
                  className={` ${inputClass} tw-w-full tw-bg-transparent tw-border tw-border-black/10 tw-text-[gray] tw-rounded-lg tw-h-12 tw-rounded-xl tw-text-sm tw-indent-5 `}
                />
              </label>
              <span
                className={` ${
                  inputValue !== "" ? "tw-hidden" : "tw-flex"
                } tw-text-sm tw-text-[red] tw-font-medium`}
              >
                {inputError}
              </span>
            </form>

            <div className="tw-flex tw-w-full tw-items-center tw-gap-2">
              <button
                onClick={leftbtnfunc}
                className={`${leftbtnClass} tw-text-[#CDDC28] tw-bg-transparent tw-border tw-border-[#CDDC28] tw-text-sm tw-p-2 tw-h-10 tw-w-full  tw-rounded-md`}
              >
                {leftbtn}
              </button>
              <button
                type=""
                disabled={disabled}
                onClick={rightbtnfunc}
                className={`${rightbtnClass} tw-p-2 tw-h-10 tw-w-full ila-bg text-white tw-text-sm tw-rounded-md`}
              >
                {rightbtn}
              </button>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default DefaultModal;
